import React from 'react'
import {Briefcase, Users, Wrench} from 'lucide-react'

const audiences = [
  {
    icon: Briefcase,
    title: 'Freelancers',
    description: 'Create professional invoices instantly and get paid faster. Perfect for designers, writers, developers, and consultants.'
  },
  {
    icon: Users,
    title: 'Consultants',
    description: 'Professional tax invoice templates for consulting services. Impress clients with polished, detailed invoices.'
  },
  {
    icon: Wrench,
    title: 'Tradespeople',
    description: 'Quick invoice generator for plumbers, electricians, handymen, and contractors. Simple invoice software built for trades.'
  }
]

const TargetAudience = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {audiences.map((audience, index) => (
        <div 
          key={index}
          className="text-center p-6"
        >
          <div className="w-16 h-16 bg-[#0B5394] bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4">
            <audience.icon className="w-8 h-8 text-[#0B5394]" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-3">
            {audience.title}
          </h3>
          <p className="text-gray-600">
            {audience.description}
          </p>
        </div>
      ))}
    </div>
  )
}

export default TargetAudience
